<h1 mat-dialog-title>{{dialogData.header}}</h1>
<mat-dialog-content class="mat-typography">
    <h4 *ngIf="dialogData.message">
        {{dialogData.message}}
    </h4>
    <div class="custom-content-wrapper">
        <ng-container *ngTemplateOutlet="dialogData.template; context: contentContext"></ng-container>
    </div>
</mat-dialog-content>
<mat-dialog-actions>

    <button *ngFor="let action of dialogData.additionalActions" [class]="action.buttonThemeClass" mat-button (click)="actionButtonClick(action)">
        <span style="font-size: 16px">
            {{action.text}}
        </span>
    </button>
    <button class="theme-button--primary" mat-button cdkFocusInitial (click)="cancelButtonClick()">
        <span style="font-size: 16px">
            {{dialogData.cancelButtonText}}
        </span>
    </button>
</mat-dialog-actions>